import { useContext, useMemo } from "react";
import { NavContext } from "../Nav/NavContext";
import {
  hasSubscription as hasSubscriptionFn,
  isLoggedIn,
  isPremium,
  isPro as isProFn
} from "../utils";

export function useUser() {
  const [{ user, onLoginRequestCallback, onLogoutRequestCallback }] = useContext(NavContext);

  const loggedIn = useMemo(() => isLoggedIn(user), [user]);
  const premium = useMemo(() => isPremium(user), [user]);
  const hasSubscription = useMemo(() => hasSubscriptionFn(user), [user]);
  const isPro = useMemo(() => isProFn(user), [user]);
  const clinicName = useMemo(() => user?.pro?.group.title ?? "", [user?.pro]);
  const { firstName, lastName } = useMemo(() => user ?? { firstName: "", lastName: "" }, [user]);

  const loginRequest = (u: string, p: string) => onLoginRequestCallback?.(u, p);
  const logoutRequest = () => onLogoutRequestCallback?.();

  return {
    user,
    loggedIn,
    premium,
    hasSubscription,
    isPro,
    clinicName,
    firstName,
    lastName,
    loginRequest,
    logoutRequest
  };
}
